import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'gatsby-link'

import style from '../utils/styles'
import { rhythm } from '../utils/typography'

const Button = styled(Link)`
  border-radius: 4px;
  display: inline-block;
  transition: all 0.25s ease;
  font-size: ${rhythm(1)};
  line-height: 1;
  font-style: normal;
  padding: ${rhythm(0.5)} ${rhythm(3)};
  margin: ${rhythm(0.25)} auto;
  text-transform: uppercase;
  border: 1px solid transparent;

  &:hover,
  &:focus {
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
  }

  &:active {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
  }

`

export const ButtonGreen = Button.extend`
  background-color: ${style.green};
  color: white;

  &:hover,
  &:focus,
  &:active {
    color: ${style.green};
    background-color: white;
    border: 1px solid #5a5a5a;
  }
`

export const ButtonWhite = Button.extend`
  background-color: white;
  color: ${style.green};
  border: 1px solid #5a5a5a;

  &:hover,
  &:focus,
  &:active {
    color: white;
    background-color: ${style.green};
  }
`

export default Button;


// WEBPACK FOOTER //
// ./src/layouts/button.js